import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'cardSubType',
  standalone: false,
})
export class CardSubTypePipe implements PipeTransform {
  /**
   * Return transformed learning type string to show or not show the card sub type which is
   * the learning type string. Currently Learning Type  of eLearning is shown, all other
   * learning types are empty string or not shown.
   * @param learningType - learning type to transform to new display type else empty string, if not shown.
   * @returns - transformed learning type string
   */
  public transform(learningType: string): string {
    switch (learningType) {
      case Learning_Type.SUBSCRIPTION:
        return '';
      case Learning_Type.WORKSHOP:
        return Learning_Type.WORKSHOP;
      case Learning_Type.E_LEARNING:
        return Learning_Type.E_LEARNING;
      case Learning_Type.QUICK_LEARNING:
        return Learning_Type.QUICK_LEARNING;
      case Learning_Type.WEBINAR:
        return Learning_Type.WEBINAR;
      case Learning_Type.CERTIFICATION_EXAM:
      case Learning_Type.SELF_STUDY:
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
        return '';
      default:
        return '';
    }
  }
}
